export default function Loading() {
  return (
    <div style={{ display: 'flex', gap: 6, padding: '12px 0' }}>
      <span className="loading-dot" style={{ animationDelay: '0s' }} />
      <span className="loading-dot" style={{ animationDelay: '0.2s' }} />
      <span className="loading-dot" style={{ animationDelay: '0.4s' }} />
    </div>
  );
}
